import { useCallback } from "react";

import { useShallow } from "zustand/react/shallow";

import { useAppPWAStateStore } from "app/stores/useAppPWAStateStore";
import { useEmployeeStore } from "app/stores/useEmployeeStore";
import { useLayoutStore } from "app/stores/useLayoutStore";

const closeUpdateAppModal = () => useLayoutStore.setState({ showUpdateAppModal: false });

export function useAppUpdate() {
  const updateServiceWorker = useAppPWAStateStore((state) => state.updateServiceWorker);
  const setAppLayout = useLayoutStore((state) => state.setAppLayout);
  const { setEmployee, isIdentified } = useEmployeeStore(
    useShallow((state) => ({
      setEmployee: state.setEmployee,
      isIdentified: state.isIdentified,
    })),
  );

  return useCallback(() => {
    if (!updateServiceWorker) {
      closeUpdateAppModal();
      return;
    }
    closeUpdateAppModal();
    setAppLayout({ isUpdating: true });
    if (isIdentified) {
      setEmployee({ persistDuringUpdatePageRefresh: true });
    }
    updateServiceWorker();
  }, [updateServiceWorker, setAppLayout, isIdentified, setEmployee]);
}
